import { useMemo } from "react";

import { useAllCompanies } from "~/modules/client/api/company/companyQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


export const useCompanySelectOptions = (): FormInputOption[] => {
	const { data: companies } = useAllCompanies();
	return useMemo(() => {
		if (companies) {
			return companies
				.sort(byObjectProperty("displayName"))
				.map((company) => {
					return createInputOptionData(company.displayName, company.id);
				});
		}
		return [];
	}, [companies]);
};

